var _defs, _g, _g2, _g3, _g4, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.98,80.75h101.76c6.63,0,11.05,5.37,9.88,12l-21.63,122.65H71.24c-6.63,0-11.05-5.37-9.88-12l19.51-110.65c1.17-6.63,7.49-12,14.12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.72,109.24h31.2l-7.74,43.9h34.3l11.82,5.57c2.88,1.36,4.24,4.53,3.39,7.92l-10.33,41.35c-1.04,4.18-5.09,7.41-9.29,7.41h-72.07l18.72-106.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.48,153.14h-34.3l7.74-43.9h14.79c3.51,0,6.2,2.28,6.65,5.63l5.12,38.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 105.79,
    cy: 215.4,
    rx: 26.05,
    ry: 21.84,
    transform: "translate(-117.7 127.99) rotate(-42.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 105.79,
    cy: 215.4,
    rx: 11.07,
    ry: 9.28,
    transform: "translate(-117.7 127.99) rotate(-42.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 224.43,
    cy: 215.4,
    rx: 26.05,
    ry: 21.84,
    transform: "translate(-86.56 208.11) rotate(-42.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 224.43,
    cy: 215.4,
    rx: 11.07,
    ry: 9.28,
    transform: "translate(-86.56 208.11) rotate(-42.48)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 45.83,
    y1: 109.12,
    x2: 100.23,
    y2: 109.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25.37,
    y1: 109.12,
    x2: 33.18,
    y2: 109.12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 34.83,
    y1: 132.94,
    x2: 89.23,
    y2: 132.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 102.73,
    y1: 132.94,
    x2: 120.54,
    y2: 132.94
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 43.83,
    y1: 154.69,
    x2: 98.23,
    y2: 154.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.37,
    y1: 154.69,
    x2: 31.18,
    y2: 154.69
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.06,
    y1: 178.51,
    x2: 77.47,
    y2: 178.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus7);
export default __webpack_public_path__ + "static/media/whyus7.9e0a194ba2593a6ad7585473b7f4c49e.svg";
export { ForwardRef as ReactComponent };